<igo-context-edit (submitSuccessed)="submitSuccessed()" />
